'use client'

import { css, styled } from 'styled-components'

import { Tag } from '@b-stock/fe-core/bstock-react'

const BaseSkeleton = styled.div`
  width: 100%;
  border-radius: 0.25rem;
  position: relative;
  background: linear-gradient(270deg, transparent -25%, currentcolor 100%);
  animation: listing-skeleton-pulse 1s ease-in-out 0.5s infinite;

  opacity: 0.1;
  @keyframes listing-skeleton-pulse {
    0% {
      opacity: 0.1;
    }

    50% {
      opacity: 0.05;
    }

    100% {
      opacity: 0.1;
    }
  }
`

// ~25% lighter than the default tag color
export const TagSkeleton = styled(Tag)`
  background-color: #f8f9fb;
`

export const ImageSkeleton = styled(BaseSkeleton)`
  width: 14.75rem;
  height: 10.5rem;
`

export const LogoSkeleton = styled(BaseSkeleton)`
  width: 6.375rem;
  height: 1.5rem;
`

const SkeletonTextLineWrapper = styled.div<{
  $width: `${number}rem` | `${number}%`
  $tag?: boolean
}>`
  display: grid;
  grid-template-columns: 0 1fr;
  align-items: center;

  ${({ $tag }) =>
    $tag
      ? css`
          overflow: hidden;
        `
      : null}
  width: ${({ $width }) => $width};
  > ${BaseSkeleton} {
    ${({ $tag }) =>
      $tag
        ? css`
            height: 100%;
          `
        : css`
            height: 90%;
          `}
  }
`

export const SkeletonTextLine = ({
  testIdSuffix: testId,
  width,
  tag,
}: {
  testIdSuffix: string
  width: `${number}rem` | `${number}%`
  tag?: boolean
}) => {
  return (
    <SkeletonTextLineWrapper $width={width} $tag={tag}>
      {/* Zero-width space */}
      &#8203;
      <BaseSkeleton data-testid={`skeleton-${testId}`} />
    </SkeletonTextLineWrapper>
  )
}
